/// <reference types="vite/client" />

/** A locale file as `import.meta.glob` loads it: the YAML's messages as default export. */
export type LocaleModule = { default: Record<string, unknown> };

/**
 * The texts of this package (`./locales/*.yaml`), globbed relative to this module like the
 * pattern library's `baseLocales`, so an app at any depth finds them. Apps merge them into their
 * vue-i18n messages: the website through astro-core's `createI18nFactory`, the portal in
 * `src/i18n/i18n.ts`.
 */
export const uiLocales: Record<string, () => Promise<LocaleModule>> = import.meta.glob<LocaleModule>(
  "./locales/*.yaml",
);
